import { TableCell } from '@/components/ui/table';
import { formatNumber } from '@/utils/format/number';
import type { UnitOverviewRow } from '@/warranty-v3/entities/overview';

type CyclesTotalCellProps = {
  row: UnitOverviewRow;
};

export function CyclesTotalCell({ row }: CyclesTotalCellProps) {
  return (
    <TableCell narrow justify="left">
      {typeof row.cyclesTotal === 'number'
        ? formatNumber(row.cyclesTotal)
        : '-'}
    </TableCell>
  );
}
